import _ from 'underscore';
import Backbone from 'backbone';
import PageView from 'views/main/PageView';
import Loadable from 'utils/extensions/Loadable';
import SystemMessagePageView from 'views/main/SystemMessagePageView';
import AlertMessagesView from 'views/main/AlertMessagesView';
import templateHtml from 'containers/fullpage/PageContainer.html';

var LoadableView = Backbone.View.extend(Loadable);

export default LoadableView.extend({
    initialize: function(args) {
        this.userPreferences = args.userPreferences;
        this.pageView = null;
        this.registeredApplicationEvents = {}; // List of application events that have been registered

        this.template = _.template(templateHtml);
    },

    render: function() {
        if (this.pageView && this.pageView.isLoaded()) {
            this.$el.empty();
            this.$el.removeClass();
            this.$el.addClass('content page');
            this.$el.addClass(this.pageView.pageClassName);

            this.$el.html(this.template({}));

            var $pageContainer = this.$('#pageContainer');
            $pageContainer.append(this.pageView.el);

            if (this.isFluid()) {
                $pageContainer.addClass('page-inner-fluid');
            }

            if (this.pageView.enableContainerCss) {
                $pageContainer.addClass('container');
            }

            window.scrollTo(0, 0);

            this.setupPageMessages();
            this.pageView.render();
            this.addBodyLevelClass();

            jQuery('body').removeClass('wait');
        }
    },

    /**
     * Add data-body-level-class attribute to the body in order to handle customized printing functionality
     */
    addBodyLevelClass: function() {
        if (this.pageView.pageClassName) {
            var classes = this.pageView.pageClassName.trim().split(' ');

            classes = _.map(classes, function(cls) {
                return 'body-' + cls;
            });

            jQuery('body').addClass(classes.join(' '));
        }
    },

    setupPageMessages: function() {
        //displays yellow system messages at the top of the page
        this.systemMessagePageView = new SystemMessagePageView({
            el: this.$('.system-message-container'),
            systemMessageText: this.pageView.getSystemMessage(),
            shouldDisplayMessages: this.pageView.enableSystemMessage
        });

        this.listenTo(this.systemMessagePageView, SystemMessagePageView.Events.SYSTEM_MESSAGE_RENDERED, function() {
            if (this.pageView && _.isFunction(this.pageView.handleListPadding)) {
                this.pageView.handleListPadding();
            }
        });

        this.systemMessagePageView.load();

        //displays alerts (success and failures of an action) at the top of the page
        this.alertMessagesView = new AlertMessagesView({
            pageViewSuccessMessage: this.pageView.getSuccessMessage(),
            pageViewFailureMessage: this.pageView.getFailureMessage(),
            pageViewInfoMessage: this.pageView.getInfoMessage(),
            growl: this.pageView.growlMessages
        });

        this.listenTo(this.alertMessagesView, AlertMessagesView.Events.ON_MESSAGE_CLOSED, function() {
            if (this.pageView && _.isFunction(this.pageView.onMessageClosed)) {
                this.pageView.onMessageClosed();
            }
        });

        this.$('.system-message-container').after(this.alertMessagesView.render().el);

        this.bindPageViewEvents();
    },

    /**
     * Sets the page view that will be rendered in the PageContainer.
     * @param pageView the PageView to display. May be null.
     */
    setPageView: function(pageView) {
        if (this.pageView) {
            this.pageView.onPageUnloaded();
        }

        this.pageView = pageView;

        this.registerApplicationEvents(this.pageView);

        if (this.pageView) {
            if (this.pageView.isLoaded()) {
                this.render();
            } else {
                this.pageView.once(
                    pageView.Loadable.Events.ON_DEPENDENCIES_LOADED,
                    this.onPageDependenciesLoaded,
                    this
                );
            }
        }
    },

    /**
     * Called when the child pages dependencies have been loaded, meaning its okay to render.
     */
    onPageDependenciesLoaded: function() {
        this.render();
    },

    /**
     * Dynamically applies the the given css text.
     * @param css contents to inject into the DOM.
     */
    setApplicationCss: function(css) {
        $("<style type='text/css'>" + css + '</style>').appendTo('head');
    },

    /**
     * Called when the page container has been unloaded. Performs cleanup.
     */
    onContainerUnloaded: function() {
        if (this.pageView) {
            this.pageView.onPageUnloaded();
            this.off();
            this.stopListening();
        }
    },

    bindPageViewEvents: function() {
        if (this.pageView) {
            this.pageView.on(PageView.Events.HIDE_PAGE_VIEW_SUCCESS_MESSAGE, this.hideSuccessMessage, this);
            this.pageView.on(PageView.Events.SHOW_PAGE_VIEW_SUCCESS_MESSAGE, this.showSuccessMessage, this);
            this.pageView.on(PageView.Events.HIDE_PAGE_VIEW_FAILURE_MESSAGE, this.hideFailureMessage, this);
            this.pageView.on(PageView.Events.SHOW_PAGE_VIEW_FAILURE_MESSAGE, this.showFailureMessage, this);
            this.pageView.on(PageView.Events.HIDE_PAGE_VIEW_INFO_MESSAGE, this.hideInfoMessage, this);
            this.pageView.on(PageView.Events.SHOW_PAGE_VIEW_INFO_MESSAGE, this.showInfoMessage, this);
            this.pageView.on(PageView.Events.HIDE_ALL_PAGE_VIEW_MESSAGES, this.hideAllMessages, this);
        }
    },

    /**
     * Given a PageView, registers any ApplicationEvent the Page wants to listen to.
     */
    registerApplicationEvents: function(pageView) {
        for (var eventName in pageView.applicationEvents) {
            if (pageView.applicationEvents.hasOwnProperty(eventName)) {
                var handlerName = pageView.applicationEvents[eventName];
                var callback = pageView[handlerName];

                if (!callback) {
                    console.log('Handler not found for event: ' + eventName);
                    return;
                }

                if (!this.registeredApplicationEvents[eventName]) {
                    this.registeredApplicationEvents[eventName] = [];
                }

                this.registeredApplicationEvents[eventName].push({
                    callback: callback,
                    context: pageView
                });
            }
        }

        pageView.bind(PageView.Events.ON_APPLICATION_EVENT_TRIGGERED, this.handleApplicationEvent, this);
    },

    registerApplicationEvent: function(eventName, context, callback) {
        if (!this.registeredApplicationEvents[eventName]) {
            this.registeredApplicationEvents[eventName] = [];
        }

        this.registeredApplicationEvents[eventName].push({
            callback: callback,
            context: context
        });
    },

    /**
     * Raises an application event with the given name. Any extra argument provided will be provided
     * to the callback.
     *
     * @param originator the object that triggered the event.
     * @param eventName the applicationEvent name (Ex. 'ACTIVITY_ADDED').
     */
    raiseApplicationEvent: function(originator, eventName) {
        this.handleApplicationEvent(arguments);
    },

    /**
     * Handles application events by invoking the event on any page that registers for it.
     * @param args
     *
     *      0: originator
     *      1: event name
     *      .. additional arguments
     */
    handleApplicationEvent: function(args) {
        var registeredEvents = this.registeredApplicationEvents[args[1]];

        // Remove the second object. No need for the event name.
        var callbackArgs = [];
        callbackArgs.push(args[0]); // This is the object that triggered the event
        for (var i = 2; i < args.length; i++) {
            callbackArgs.push(args[i]);
        }

        _.each(registeredEvents, function(registeredEvent) {
            registeredEvent.callback.apply(registeredEvent.context, callbackArgs);
        });
    },

    isFluid: function() {
        var fluid = this.pageView.fluid;
        if (typeof fluid == 'function') {
            fluid = fluid.call(this.pageView);
        }
        return fluid;
    },

    isNewGrid: function() {
        var grid = this.pageView.enableGridCss;
        if (typeof grid == 'function') {
            grid = grid.call(this.pageView);
        }
        return grid;
    },

    //page alert message methods
    hideSuccessMessage: function(clearText) {
        if (this.alertMessagesView && typeof this.alertMessagesView.hideSuccessMessage === 'function') {
            this.alertMessagesView.hideSuccessMessage(clearText);
        }
    },

    showSuccessMessage: function(message) {
        if (this.alertMessagesView && typeof this.alertMessagesView.showSuccessMessage === 'function') {
            this.alertMessagesView.showSuccessMessage(message);
        }
    },

    hideFailureMessage: function(clearText) {
        if (this.alertMessagesView && typeof this.alertMessagesView.hideFailureMessage === 'function') {
            this.alertMessagesView.hideFailureMessage(clearText);
        }
    },

    showFailureMessage: function(message) {
        if (this.alertMessagesView && typeof this.alertMessagesView.showFailureMessage === 'function') {
            this.alertMessagesView.showFailureMessage(message);
        }
    },

    hideInfoMessage: function(clearText) {
        if (this.alertMessagesView && typeof this.alertMessagesView.hideInfoMessage === 'function') {
            this.alertMessagesView.hideInfoMessage(clearText);
        }
    },

    showInfoMessage: function(message) {
        if (this.alertMessagesView && typeof this.alertMessagesView.showInfoMessage === 'function') {
            this.alertMessagesView.showInfoMessage(message);
        }
    },

    hideAllMessages: function(clearText) {
        this.hideSuccessMessage(clearText);
        this.hideFailureMessage(clearText);
        this.hideInfoMessage(clearText);
    }
});
